import React from "react";
import { Typography, CardContent, Card, CardMedia, Grid, Button, Avatar, Box, CardActions, useMediaQuery, IconButton, Stack, } from "@mui/material";
import Link from "next/link";
import { Article } from "../../../interfaces/community/article";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight, faPaw } from "@fortawesome/free-solid-svg-icons";
import he from "he";
import { Config, ImgUrl } from "@/config";
import { useDispatch } from "react-redux";
import { setTagId } from "@/store/slices/articleActivitySlice";
import { useRouter } from "next/router";
import CustomImageOnError from "@/hoc/WithFallbackImageError";
import Image from "next/image";

interface Props {
  dataSet: Article;
  // searchTag?: boolean;
  // searchTagLink?: boolean;
  // initialActivityDetail:any
}

export default function ArticlesAll({ dataSet,
  // searchTag, 
  // searchTagLink, 
  // initialActivityDetail 
}: Props) {


  // console.log('dataSet : ', dataSet);

  const dispatch = useDispatch();
  const router = useRouter()
  const imagedefault = "/assets/images/logo/logomaboom.png"
  const isMobile = useMediaQuery('(max-width:600px)');

  // const scrollContainer = React.useRef(null);
  // const handleScroll = (direction: any) => {

  //   if (scrollContainer.current) {
  //     scrollContainer.current.scrollBy({
  //       left: direction == 'left' ? -100 : 100,
  //       behavior: 'smooth',

  //     });
  //   }
  // };

  const handleTagClick = (event: React.MouseEvent<HTMLButtonElement>, tagId: number) => {
    event.stopPropagation();
    event.preventDefault();
    dispatch(setTagId(tagId));
    // if (searchTagLink) {
    if (dataSet.articleCategoryRelations[0].categoryId === 1) {
      router.push(`/community/articles`);
    } else {
      router.push(`/community/activity`);
    }
    // }
  };

  const aspectRatio = 3 / 2; // เปลี่ยนเป็นอัตราส่วนภาพ 3:2 // ตัวอย่างอัตราส่วนภาพ
  const width = 420; // กำหนดความกว้าง container
  const height = width / aspectRatio;

  return (
    <>
      <Box sx={{ height: "100%" }}>
        <Link href={`/community/article/${dataSet.slug}`} style={{
          textDecoration: 'none', display: "inline-block",
          height: "100%",
          // padding: "0 5px",
        }}>
          <Card
            className="box-shadow-center"
            sx={{
              cursor: 'pointer',
              borderRadius: "14px",
              height: '100%',
              paddingBottom: "5px !important"
              // maxHeight: '500px'
            }}
          >
            <CardContent sx={{ position: 'relative', p: 0 }}>
              {dataSet.desktopCoverImage && (
                <Image
                  src={dataSet.desktopCoverImage
                    ? `${ImgUrl.imageUrlCenter}uploads/articles/${dataSet.desktopCoverImage}`
                    : imagedefault}  // Fallback ไปที่ imagedefault ถ้าไม่มี desktopCoverImage
                  alt={dataSet.articleTitle || "Maaboom image"}
                  width={width}
                  height={height}
                  style={{
                    width: '100%',  // ทำให้ภาพเป็น responsive ตามคอนเทนเนอร์
                    height: 'auto',
                    objectFit: 'cover',  // ทำให้ครอบภาพตามที่ต้องการ
                  }}
                  loading="lazy"
                  placeholder="empty"
                  blurDataURL={dataSet.desktopCoverImage
                    ? `${ImgUrl.imageUrlCenter}uploads/articles/${dataSet.desktopCoverImage}`
                    : imagedefault}
                />
                // <Image
                //   src={dataSet.desktopCoverImage
                //     ? `${ImgUrl.imageUrlCenter}uploads/articles/${dataSet.desktopCoverImage}`
                //     : imagedefault}  // Fallback to imagedefault if desktopCoverImage is not available
                //   alt={dataSet.articleTitle || "Maaboom image"}
                //   width={width}
                //   height={height}
                //   layout="responsive"
                //   objectFit="cover"
                //   // priority
                //   style={{ objectFit: 'cover', }}
                //   loading="lazy"
                //   placeholder="empty"
                //   blurDataURL={dataSet.desktopCoverImage
                //     ? `${ImgUrl.imageUrlCenter}uploads/articles/${dataSet.desktopCoverImage}`
                //     : imagedefault}
                // />
              )}
              {dataSet.writer?.WriterImageFullPath && (
                <Avatar
                  src={dataSet.writer.WriterImageFullPath}
                  alt={dataSet.articleTitle || "Writer Avatar"}
                  sx={{
                    width: 40,
                    height: 40,
                    position: 'absolute',
                    bottom: 8,
                    left: 8,
                    border: '2px solid white',
                    zIndex: 1,
                  }}
                />
              )}
            </CardContent>
            <CardContent sx={{ paddingBottom: "0 !important" }}>
              <Typography
                variant="h6"
                component="h2"
                gutterBottom
                sx={{
                  display: '-webkit-box',
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  WebkitLineClamp: 2,
                  fontSize: "18px",
                  // lineHeight: "22px",
                  // maxHeight: "44px",
                }}
                className="txt-bold"
              >
                {dataSet.articleTitle ? dataSet.articleTitle : 'Untitled'}
              </Typography>
              <Typography
                variant="body2"
                color="textSecondary"
                gutterBottom
                sx={{
                  display: '-webkit-box',
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  WebkitLineClamp: 2,
                  // height: 40
                }}
              >
                {dataSet.articleShortDesc ? dataSet.articleShortDesc : 'No description available.'}
              </Typography>
              {/* {searchTag && (
                <Grid container alignItems="center" sx={{ alignItems: 'start', mt: 2 }}>
                  <Grid
                    container
                    sx={{
                      display: '-webkit-box',
                      WebkitBoxOrient: 'vertical',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      WebkitLineClamp: 1,
                    }}
                  >
                    {dataSet.articleTagRelationAllInArticle?.map((tagData, i) => (
                      <Button
                        key={`${dataSet.id}-${i}`}
                        variant="contained"
                        onClick={(event) => handleTagClick(event, tagData.tagId)}
                        sx={{
                          borderColor: '#f9dfb9',
                          bgcolor: '#f9dfb9',
                          '&:hover': {
                            borderColor: '#f9dfb9',
                            bgcolor: '#f9dfb9',
                          },
                          color: '#292929',
                          fontSize: '10px',
                          whiteSpace: 'nowrap',
                          minWidth: 'auto',
                          py: '2px',
                          px: '5px',
                          mr: 1
                        }}
                      >
                        #{tagData.articleTag.tagTitle}
                      </Button>
                    ))}
                  </Grid>
                </Grid>
              )} */}
              <Typography sx={{
                display: '-webkit-box',
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                WebkitLineClamp: 1,
              }} variant="caption" component="p" color="textSecondary">
                by <strong>{dataSet.writer?.writerName || 'Unknown'}</strong>{' '}
                <FontAwesomeIcon icon={faPaw} /> {dataSet.createdAt || 'Date unknown'}
              </Typography>
            </CardContent>
          </Card>
        </Link>
      </Box>
    </>
  );
}
